import _merge from 'lodash/merge';
import ReactPlayer from 'react-player';
import React from 'react';
const getSolidColorUrl = color => `data:image/svg+xml,%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3crect fill='${encodeURIComponent(color)}'  x='0' y='0' width='100%25' height='100%25'%3e%3c/rect%3e%3c/svg%3e`;
const BackgroundImage = ({
  backgroundColor,
  onBackgroundClick,
  className,
  onReady,
  onPlay,
  onError,
  src,
  useCors
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "BackgroundImage",
    style: {
      backgroundColor,
      width: '100%',
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: "spotlight",
    className: className,
    src: src,
    onClick: typeof onBackgroundClick === 'function' ? onBackgroundClick : undefined,
    onError: onError,
    onLoad: () => {
      onReady && onReady();
      onPlay && onPlay();
    },
    crossOrigin: useCors ? 'anonymous' : undefined
  }));
};
const Background = ({
  volume,
  background,
  playing,
  onProgress,
  loop,
  muted,
  onReady,
  onPlay,
  onPause,
  onEnded,
  onError,
  onDuration,
  onBackgroundClick,
  hasSideUpcode,
  metadata,
  useCors,
  reactPlayerRef,
  reactPlayerConfig
}) => {
  const className = 'Background';
  const background_color = metadata.background_color;
  let type = background === null || background === void 0 ? void 0 : background.type;
  if (!type || type === '') {
    type = 'solid';
  }
  let url = background === null || background === void 0 ? void 0 : background.url;
  if (!url || url === '') {
    url = getSolidColorUrl(background_color);
  }
  switch (type) {
    case 'youtube':
    case 'video':
      {
        const config = _merge({
          file: {
            attributes: {
              crossOrigin: useCors ? 'anonymous' : undefined
            }
          }
        }, reactPlayerConfig !== null && reactPlayerConfig !== void 0 ? reactPlayerConfig : {});
        const reactPlayerProps = {
          className,
          url,
          width: hasSideUpcode ? '1220px' : '100%',
          height: '100%',
          controls: false,
          loop,
          muted,
          playing,
          onProgress,
          progressInterval: 100,
          volume: muted ? 0 : volume,
          onReady,
          onPlay,
          onPause,
          onEnded,
          onError,
          onDuration,
          config,
          ref: reactPlayerRef
        };
        return /*#__PURE__*/React.createElement(ReactPlayer, reactPlayerProps);
      }
    case 'image':
    case 'gradient':
    case 'solid':
    default:
      return /*#__PURE__*/React.createElement(BackgroundImage, {
        backgroundColor: background_color,
        className: className,
        src: url,
        onReady: onReady,
        onPlay: onPlay,
        onBackgroundClick: onBackgroundClick,
        onError: onError,
        useCors: useCors
      });
  }
};
export default Background;